export default __webpack_public_path__ + "static/media/brand-12.1ea7ede3.png";